import { PriorityEnum } from "../../enum";


export class SampleIdRequest{
    sampleRequestId:number;
    priority?:PriorityEnum;

    constructor(sampleRequestId:number,priority?:PriorityEnum){
        this.sampleRequestId = sampleRequestId;
        this.priority = priority;


    }
}
